import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";
// import StarBorderIcon from '@mui/icons-material/StarBorder';
import { colors } from "../../Shared/colors";
import {
  useDeleteClientMutation,
  useEditClientMutation,
} from "../../features/clientSlice";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Toaster, toast } from "react-hot-toast";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { decryptData } from "../../services/crypto";

export const ClientsDatatable = ({ clients, isAutoFetching, pageSize, setPageSize, setPage, currentPage = 0 }) => {
  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      // Silent fallback - session may be expired
      role = null;
    }
  }
  
  const [numberPopUp, setnumberPopUp] = useState(false);

  const [clientId, setclientId] = useState(null);

  const [popUp, setpopUp] = useState(false);

  const [phoneData, setphoneData] = useState([]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        setpopUp(false);
        setnumberPopUp(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const [clientData, setclientData] = useState({
    firstName: "",
    newPhoneNo: "",
  });

  const [editClient, { isLoading }] = useEditClientMutation();
  const [deleteClient] = useDeleteClientMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setclientData({
      ...clientData,
      [name]: value,
    });
  };

  const handleDeleteClient = (id) => {
    deleteClient(id)
      .unwrap()
      .then((res) => {
        toast.success("Client deleted Successfully!");
      })
      .catch((err) => {
        toast.error("Error deleting client!");
      });
  };
  const handleClientSave = (e) => {
    e.preventDefault();
    let id = clientId;
    let body = {
      firstName: clientData.firstName,
      lastName: clientData.lastName,
      newPhoneNo: clientData.newPhoneNo,
    };
    editClient({ id, body })
      .unwrap()
      .then((res) => {
        toast.success("Client Updated Successfully");
        setclientData({
          firstName: "",
          lastName: "",
          email: "",
          newPhoneNo: "",
        });
        setpopUp(false);
      })
      .catch((err) => {
        toast.error(err.data.error.message || "Error updating client!");
      });
  };

  const columns = [
    {
      field: "client",
      headerName: "Client",
      width: 120,
      renderCell: (params) => {
        return (
          <Allocated>
            <Tooltip title={params.row.client}>
              <div>{params.row.client}</div>
            </Tooltip>
          </Allocated>
        );
      },
    },
    {
      field: "allocatedto",
      headerName: "Allocated To",
      width: 150,
      renderCell: (params) => {
        return (
          <Allocated>
            <Tooltip title={params.row.allocatedto}>
              <div>{params.row.allocatedto}</div>
            </Tooltip>
          </Allocated>
        );
      },
    },
    {
      field: "rating",
      headerName: "Client Rating",
      width: 150,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.phone && Array.isArray(params.row.phone) && params.row.phone.length > 1 ? (
              <PhoneButton
                onClick={() => {
                  setphoneData(params.row.phone);
                  setnumberPopUp(true);
                }}
              >
                {params.row.phone[0]?.phoneNo || "N/A"}
                <PhoneBadge>+{params.row.phone.length - 1}</PhoneBadge>
              </PhoneButton>
            ) : params.row.phone && Array.isArray(params.row.phone) && params.row.phone.length === 1 ? (
              <PhoneLink href={`tel:+${params.row.phone[0]?.phoneNo}`}>
                {params.row.phone[0]?.phoneNo || "N/A"}
              </PhoneLink>
            ) : (
              <span style={{ color: colors.textMed }}>No phone</span>
            )}
          </div>
        );
      },
    },
    {
      field: "buyingIntent",
      headerName: "Buying Intent",
      width: 150,
    },
    {
      field: "clientOccupation",
      headerName: "Client Occupation",
      width: 150,
    },
    {
      field: "clientType",
      headerName: "Client Type",
      width: 150,
    },
    {
      field: "country",
      headerName: "Country",
      width: 150,
    },
    {
      field: "action",
      headerName: "Actions",
      width: 120,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        return (
          <Action>
            {role === "ceo" || role === "v3" ? (
              <Tooltip title="Delete Client" arrow>
                <ActionButton
                  onClick={() => handleDeleteClient(params.row.id)}
                  danger
                >
                  <DeleteIcon />
                </ActionButton>
              </Tooltip>
            ) : null}
            <Tooltip title="Edit Client" arrow>
              <ActionButton
                onClick={() => {
                  setclientId(params?.row?.id);
                  setclientData({
                    firstName: params.row?.client,
                    newPhoneNo: params.row?.phone[0]?.phoneNo,
                  });
                  setpopUp(!popUp);
                }}
              >
                <EditIcon />
              </ActionButton>
            </Tooltip>
          </Action>
        );
      },
    },
  ];

  const rows = useMemo(() => {
    const rowsData = [];
    if (clients && clients.LoginEmployeeClients && Array.isArray(clients.LoginEmployeeClients)) {
      clients.LoginEmployeeClients.forEach((client, index) => {
        if (client && client._id) {
          rowsData.push({
            client: client.fullName || "",
            allocatedto: client.allocatedTo?.firstName || client.allocatedTo?.fullName || "",
            id: client._id,
            rating: client.clientRating || "",
            buyingIntent: client.buyingIntent || "",
            clientOccupation: client.clientOccupation || "",
            clientType: client.clientType || "",
            country: client.country || "",
            email: client.email || "",
            phone: Array.isArray(client.cellNo) ? client.cellNo : [],
            createdAt: client.createdAt,
            updatedAt: client.updatedAt,
          });
        }
      });
    }
    return rowsData;
  }, [clients]);

  const exportCSV = () => {
    const headers = [
      "Client",
      "Allocated To",
      "Client Rating",
      "Phone Number",
      "Buying Intent",
      "Client Occupation",
      "Country",
      "Client Type"
    ];
    const rowsData = rows.map(row => [
      row.client,
      row.allocatedto,
      row.rating,
      row.phone[0].phoneNo,
      row.buyingIntent,
      row.clientOccupation,
      row.country,
      row.clientType
    ]);
    const csvContent = [
      headers.join(","),
      ...rowsData.map(row => row.join(","))
    ].join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "Totalclients.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Main>
      <TimeSection>
        <FilterButton active>
          All ({clients?.totalClients || 0})
        </FilterButton>
      </TimeSection>
      <LeadsSection>
        <ClientCount>
          Total Clients: <CountNumber>{clients?.totalClients || 0}</CountNumber>
        </ClientCount>
        {role === "ceo" || role === "admin" || role === "account" ? (
          <ExportButton onClick={exportCSV}>
            <FileDownloadIcon />
            Export CSV
          </ExportButton>
        ) : null}
      </LeadsSection>
      <Table>
        {rows.length === 0 && !isAutoFetching && clients ? (
          <EmptyState>
            <EmptyIcon>📊</EmptyIcon>
            <EmptyTitle>No Clients Found</EmptyTitle>
            <EmptyText>
              No clients match your current search criteria. Try adjusting your filters or search again.
            </EmptyText>
          </EmptyState>
        ) : (
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            rowsPerPageOptions={[20, 50, 100]}
            checkboxSelection
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            loading={isAutoFetching}
            pagination
            paginationMode="server"
            page={currentPage}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowCount={clients?.totalClients || 0}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "12px",
              overflow: "hidden",
              minHeight: "400px",
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #f0f0f0',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #e0e0e0',
                fontWeight: 600,
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f8f9fa',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: '2px solid #e0e0e0',
                backgroundColor: '#f8f9fa',
              },
            }}
          />
        )}
      </Table>
      <PopUpContainer popUp={numberPopUp}>
        <NumberPopUp>
          <Cross
            onClick={() => setnumberPopUp(!numberPopUp)}
            style={{ height: "5%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <NumberPopUpSection>
            {phoneData.map((phone, index) => (
              <div key={index}>
                <span style={{ fontWeight: 600, color: colors.text }}>Phone No: </span>
                <a href={`tel:+${phone.phoneNo}`}>{phone.phoneNo}</a>
              </div>
            ))}
          </NumberPopUpSection>
        </NumberPopUp>
      </PopUpContainer>
      <PopUpContainer popUp={popUp}>
        <PopUp>
          <Cross onClick={() => setpopUp(!popUp)}>
            <img
              src="/assets/icons/cross.png"
              alt="cross"
              style={{ height: "50%" }}
            />
          </Cross>
          <PopUpSection>
            <Section
              style={{
                width: "100%",
              }}
            >
              <Task>
                <InputPart>
                  <InputFeild>
                    <h3>First Name:</h3>
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      placeholder="type here..."
                      value={clientData?.firstName}
                      onChange={handleChange}
                    />
                  </InputFeild>
                  <PhoneInputFeild>
                    <h3>New Phone Number:</h3>
                    <PhoneInputContainer>
                      <PhoneInput
                        inputProps={{ name: "newPhoneNo" }}
                        country="pk"
                        placeholder="Phone Number"
                        onChange={(e) => {
                          if (e?.length <= 12) {
                            setclientData({
                              ...clientData,
                              newPhoneNo: e,
                            });
                          } else {
                            toast.error("Phone number must be 12 characters or less");
                          }
                        }}
                      />
                      {clientData.newPhoneNo?.length > 12 && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          Phone number must be 12 characters or less.
                        </p>
                      )}
                    </PhoneInputContainer>
                  </PhoneInputFeild>
                </InputPart>
              </Task>
              <ButtonPart>
                <button
                  style={{
                    backgroundColor: `${colors.textBlue}`,
                    color: `${colors.white}`,
                    opacity: isLoading ? "0.5" : "1",
                    marginLeft: "auto",
                    marginRight: "10%",
                  }}
                  type="submit"
                  disabled={isLoading}
                  onClick={handleClientSave}
                >
                  {isLoading ? <>saving...</> : <>save</>}
                </button>
              </ButtonPart>
            </Section>
          </PopUpSection>
        </PopUp>
      </PopUpContainer>
      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 90%;
  max-width: 1400px;
  background-color: ${colors.white};
  margin: 3em auto;
  min-height: 80vh;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(15, 23, 42, 0.08);
`;

const TimeSection = styled.div`
  height: auto;
  border-bottom: 2px solid ${colors.inputBorderWhite};
  display: flex;
  align-items: flex-end;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
`;

const FilterButton = styled.button`
  padding: 0.75rem 1.5rem;
  min-width: 7em;
  border: none;
  background-color: ${props => props.active ? colors.brown : colors.white};
  color: ${props => props.active ? colors.white : colors.text};
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  font-weight: ${props => props.active ? 600 : 500};
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.active ? '#1a6b6b' : colors.inputWhite};
    color: ${props => props.active ? colors.white : colors.brown};
  }
`;

const LeadsSection = styled.div`
  font-size: 1.125rem;
  padding: 1rem 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const ClientCount = styled.div`
  font-size: 1.125rem;
  color: ${colors.text};
  font-weight: 500;
`;

const CountNumber = styled.span`
  font-weight: 700;
  color: ${colors.brown};
  font-size: 1.25rem;
`;

const ExportButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.white};
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(36, 147, 147, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(36, 147, 147, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const Table = styled.div`
  min-height: 60vh;
  width: 100%;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, ${colors.white} 0%, ${colors.inputWhite} 100%);
  border-radius: 16px;
  border: 2px dashed ${colors.inputBorderWhite};
`;

const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  opacity: 0.6;
`;

const EmptyTitle = styled.h3`
  color: ${colors.text};
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
`;

const EmptyText = styled.p`
  color: ${colors.textMed};
  font-size: 1rem;
  margin: 0;
  max-width: 400px;
`;


const PhoneButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 8px;
  border: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(36, 147, 147, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.3);
  }
`;

const PhoneBadge = styled.span`
  background-color: rgba(255, 255, 255, 0.3);
  padding: 0.125rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const PhoneLink = styled.a`
  color: ${colors.textBlue};
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    color: ${colors.brown};
    text-decoration: underline;
  }
`;

const Allocated = styled.div`
  div {
    :nth-child(2) {
      color: ${colors.textMed};
    }
  }
`;

const PopUpContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${(props) => (props.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.2s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const NumberPopUp = styled.div`
  width: 90%;
  max-width: 400px;
  max-height: 50vh;
  overflow-y: auto;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s ease;
  
  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${colors.inputWhite};
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.inputBorderWhite};
    border-radius: 3px;
  }
`;

const Cross = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1.5rem;
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.2s ease;
    
    &:hover {
      transform: rotate(90deg);
    }
  }
`;

const PopUpSection = styled.div`
  margin-bottom: 2rem;
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-around;
`;

const NumberPopUpSection = styled(PopUpSection)`
  flex-direction: column;
  padding: 0 2rem 2rem 2rem;
  gap: 1rem;
  
  div {
    padding: 1rem;
    background: ${colors.inputWhite};
    border-radius: 8px;
    border: 1px solid ${colors.inputBorderWhite};
    
    a {
      color: ${colors.textBlue};
      text-decoration: none;
      font-weight: 600;
      
      &:hover {
        color: ${colors.brown};
        text-decoration: underline;
      }
    }
  }
`;

const Action = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
`;

const ActionButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => props.danger 
    ? 'linear-gradient(135deg, rgba(224, 66, 65, 0.1) 0%, rgba(232, 11, 11, 0.1) 100%)' 
    : 'linear-gradient(135deg, rgba(0, 114, 253, 0.1) 0%, rgba(0, 86, 179, 0.1) 100%)'};
  border: 1px solid ${props => props.danger ? 'rgba(224, 66, 65, 0.2)' : 'rgba(0, 114, 253, 0.2)'};
  
  .MuiSvgIcon-root {
    color: ${props => props.danger ? colors.hot : colors.textBlue};
    transition: all 0.3s ease;
  }
  
  &:hover {
    background: ${props => props.danger 
      ? 'linear-gradient(135deg, rgba(224, 66, 65, 0.2) 0%, rgba(232, 11, 11, 0.2) 100%)' 
      : 'linear-gradient(135deg, rgba(0, 114, 253, 0.2) 0%, rgba(0, 86, 179, 0.2) 100%)'};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${props => props.danger 
      ? 'rgba(224, 66, 65, 0.3)' 
      : 'rgba(0, 114, 253, 0.3)'};
    
    .MuiSvgIcon-root {
      transform: scale(1.1);
    }
  }
  
  &:active {
    transform: translateY(0);
  }
`;
const InputPart = styled.div`
  h3 {
    font-size: clamp(1.5em, 2vh, 3em);
  }
`;

const PhoneInputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
`;

const PhoneInputContainer = styled.div`
  width: 100%;
  position: relative;
  .react-tel-input {
    .form-control {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      border: 1px solid ${colors.inputBorderWhite};
      padding: 1em 0em 1em 3em;
      background-color: ${colors.inputWhite};
    }
    .flag-dropdown {
      border: 1px solid ${colors.inputBorderWhite};
      border-radius: 6px 0 0 6px;
    }
    .selected-flag,
    .selected-flag:hover {
      background: none;
    }
  }

  .css-i4bv87-MuiSvgIcon-root {
    position: absolute;
    top: 50%;
    right: 2%;
    transform: translateY(-50%);
    color: ${colors.inputFeild};
    cursor: pointer;
  }
  .cross {
    position: absolute;
    top: 50%;
    right: 13%;
    transform: translateY(-50%);
    color: ${colors.hot};
  }
`;

const PopUp = styled.div`
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s ease;
  
  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const Section = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`;

const Task = styled.div`
  padding: 1em 2em;
  min-height: 30vh;
  height: 100%;
`;

const InputFeild = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  
  h3 {
    color: ${colors.text};
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 0.75rem 0;
  }
  
  input {
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 8px;
    background-color: ${colors.white};
    width: 100%;
    padding: 0.75rem 1rem;
    outline: none;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    ::placeholder {
      color: ${colors.inputFeild};
    }
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1.5rem 2rem;
  border-top: 1px solid ${colors.inputBorderWhite};
  gap: 1rem;
  
  button {
    min-width: 8em;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    outline: none;
    border: none;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    transition: all 0.3s ease;
    
    &[type="submit"] {
      background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
      color: ${colors.white};
      box-shadow: 0 4px 12px rgba(36, 147, 147, 0.2);
      
      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(36, 147, 147, 0.3);
      }
      
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
`;
